module.exports = __webpack_public_path__ + "static/media/gradient02.1538ad04.jpg";